/**
 * Created by yanatsylinska on 14.06.18.
 */
import { capitalize } from '../../shared/helpers/helpers';

export class AbbyResponse {
  GivenName?: string;
  LastName?: string;
  DocumentNumber?: string;
  ExpiryDate?: string;
  Sex?: string;
  BirthDate?: string;
  Nationality?: string;
  PersonalNumber?: string;
  ChecksumVerified?: string;
  BirthDateVerified?: string;
  PersonalNumberVerified?: string;
  DocumentNumberVerified?: string;
  ExpiryDateVerified?: string;


  givenNames?: string;
  lastName?: string;
  initials?: string;
  accountHolderName?: string;
  number?: string;
  expireAt?: string;
  sex?: string;
  dateOfBirth?: string;
  nationality?: string;
  personalNumber?: string;

  constructor(result: AbbyResponse) {
    this.givenNames = (result.GivenName) ? capitalize(result.GivenName) : '';
    this.lastName = (result.LastName) ? capitalize(result.LastName) : '';
    this.initials = (this.givenNames) ? this.parseInitials() : '';
    this.accountHolderName = `${this.initials} ${this.lastName}`;

    this.number = (result.DocumentNumber) ? result.DocumentNumber : '';
    this.expireAt = this.parseExpiryDate(result.ExpiryDate);

    this.sex = (result.Sex) ? result.Sex : '';

    this.dateOfBirth = (result.BirthDate) ? this.parseBirthDate(result.BirthDate) : null;
    this.nationality = (result.Nationality) ? result.Nationality : '';

    this.personalNumber = (result.PersonalNumber) ? result.PersonalNumber : '';
  }

  private parseInitials() {
    const preferredNameArray: Array<string> = this.givenNames.split(' ');
    let initials = '';

    preferredNameArray.forEach((name: string) => {
      initials = initials.concat(name.charAt(0), '.');
    });

    return initials;
  }

  private parseExpiryDate(resultValue: string) {
    let expiryYear: number, expiryDate: string;
    if (resultValue) {
      [expiryYear, expiryDate] = this.parseAbbyDate(resultValue);

      if (isNaN(expiryYear)) return '';

      const parsedDate = `20${expiryDate}`;

      return (isNaN(Date.parse(parsedDate))) ? '' : parsedDate;
    }

    return '';
  }

  private parseBirthDate(resultValue: string) {
    const [birthYear, birthDate] = this.parseAbbyDate(resultValue),
          date = new Date(),
          /* eslint-disable */
          currentYear = parseInt(date.getFullYear().toString().substr(2, 2), 10);
          /* eslint-enable */

    if (isNaN(birthYear)) return '';

    const parsedDate = (birthYear > currentYear) ? `19${birthDate}` : `20${birthDate}`;

    return (isNaN(Date.parse(parsedDate))) ? '' : parsedDate;
  }

  /* eslint-disable */
  private parseAbbyDate(date: string): [number, string] {
    const result = date.slice(0, 2) + '-' + date.slice(-4, -2) + '-' + date.slice(-2);

    return [parseInt(date.slice(0, 2), 10), result];
  };
  /* eslint-enable */
}
